import {Transport} from "data/transport";

declare var $:any;

import * as moment from 'moment';
import {POST_QUERY, GET_QUERY, stringOrEmptyString, POSTMULTIPART_QUERY} from 'utils';
import {User} from "data/entities/User";
import {API} from "api";
import {IMentionUser} from "shared/IMentionUser";


const NICKNAME_REGEX = /^(?=[a-zA-Z0-9._]{3,20}$)/

class _UserDataSource {


	constants = {
		NICKNAME_CHAR_REQUIREMENTS: 'Your nickname must be between 3 and 20 characters and contain only letters, numbers, underscores, and periods.',
		NICKNAME_LENGTH_REQUIREMENTS: 'Please choose a nickname that is at least 3 characters long.',
	}

	utils = {



		/**
		 * Only allow letters, numbers, underscores, and periods. Require 3 to 20 character length.
		 *
		 * @param nickname
		 */
		isNicknameValid: (nickname) => {
			return nickname.match(NICKNAME_REGEX);
		},
		/**
		 * Prevent multiple underscores or periods, underscores and periods following one another
		 * in order to make the username readable.
		 *
		 * @param nickname
		 */
		doesNicknameHaveIllegalCharSequence: (nickname) => {
			if(nickname && nickname.length > 1) {
				const lastChar = nickname.charAt(nickname.length - 1);
				const secondToLastChar = nickname.charAt(nickname.length - 2);
				if(('_' === lastChar || '.' === lastChar) && ('_' === secondToLastChar || '.' === secondToLastChar)) {
					return true;
				}
			}
			return false;
		},
	}

	checkNickname = (nickname:string) => new Promise<void>((resolve, reject)=>{
		$.ajax(POST_QUERY('/checkNickname', {nickname:nickname}))
			.done((result)=>{
				resolve();
			})
			.fail((e)=>{
				reject(e);
			});
	});

	attemptLoginVendor = (email, password) => this.attemptLogin(email, password, true);

	attemptLogin = (email, password, vendor?:boolean) => new Promise(((resolve, reject) => {
		$.ajax(POST_QUERY(`/auth${vendor?'Vendor':''}`, {email:email, password: password}))
			.done(response => {
				resolve(response);
			})
			.fail((jqXHR, textStatus) => {
				//console.log(jqXHR)
				if(jqXHR.responseJSON && jqXHR.responseJSON.userMessage) {
					reject(jqXHR.responseJSON);
				} else {
					reject(jqXHR.statusText);
				}
			});
	}));

	checkAuthVendor = () => this.checkAuth(true);

	checkAuth = (vendor?:boolean) => new Promise((resolve, reject) => {
		$.ajax(GET_QUERY(`/checkAuth${vendor?'Vendor':''}`))
			.done(response => {
				resolve(response);
			})
			.fail((jqXHR, textStatus) => {
				reject(textStatus);
			});
	});

	attemptTokenRefresh = () => new Promise((resolve, reject) => {
		$.ajax(GET_QUERY('/tokenRefresh'))
			.done(response => {
				resolve(response);
			})
			.fail((jqXHR, textStatus) => {
				reject(textStatus);
			});
	});

	deleteUserAccount = (email:string, password:string) => new Promise<void>((resolve, reject)=>{
    $.ajax(POST_QUERY('/deleteAccount', {email:email, password: password}))
    .done(()=>{
      resolve();
    })
    .fail(()=>{
			reject();
		});
  });

	saveUserBio = (user:User, bio) => new Promise(((resolve, reject) => {
		const formData = new FormData();
		formData.append("bio", stringOrEmptyString(bio));
		$.ajax(POSTMULTIPART_QUERY('/saveProfile', formData))
			.done(response => {
				user.bio = bio;
				resolve(response);
			})
			.fail((jqXHR, textStatus) => {
				reject(textStatus);
			});
	}));


	/**
	 * An empty or null value for avatarURL will result
	 * in the avatar being removed from the account.
	 *
	 * @param user
	 * @param profileData
	 */
	saveUserProfile = (
		user:User,
		profileData: {
			firstName?: string;
			lastName?: string;
			nickname?: string;
			bio?: string;
			avatarBlobData?:any;
			avatarURL:string|null;
			_location?:string;
		}
		) => new Promise((resolve, reject)=>{

    const formData = new FormData();
		if(undefined != profileData.firstName) {
			formData.append("firstName", stringOrEmptyString(profileData.firstName));
		}

		if(undefined != profileData.lastName) {
			formData.append("lastName", stringOrEmptyString(profileData.lastName));
		}

		if(undefined != profileData.bio) {
			formData.append("bio", stringOrEmptyString(profileData.bio));
		}

		if(undefined != profileData.nickname) {
			formData.append("nickname", stringOrEmptyString(profileData.nickname));
		}

		if(undefined != profileData._location) {
			formData.append("_location", stringOrEmptyString(profileData._location));
		}

		if(undefined != profileData.avatarBlobData) {
			const avatarName = "avatar_"+moment().format('YYYY-MM-DD-HH-mm-ss')+".png";
			formData.append("file", profileData.avatarBlobData, avatarName);
		} else {
			formData.append("avatar", profileData.avatarURL?profileData.avatarURL:'');
		}	

    $.ajax(POSTMULTIPART_QUERY('/saveProfile', formData))
	  .done(response => {
		if(undefined != response.firstName) {
			user.firstName = response.firstName;
		}
		if(undefined != response.lastName) {
			user.lastName = response.lastName;
		}
		if(undefined != response.nickname) {
			user.nickname = response.nickname;
		}
		if(undefined != response.bio) {
			user.bio = response.bio;
		}
		if(undefined != response.avatar) {
			user.avatar = response.avatar;
		}
		if(undefined != response._location) {
			user._location = response._location;
		}
		resolve(response);
	  })
	  .fail((jqXHR, textStatus) => {
			reject(textStatus);
	  });
	});




	saveUserGoals = (user:User, goals) => new Promise((resolve, reject)=>{
		$.ajax(POST_QUERY('/goals', { goals: goals } ))
	  .done(response => {
	    user.goals = goals;
			resolve(response);
	  })
	  .fail((jqXHR, textStatus) => {
			reject(textStatus);
	  });
	});

	saveUserTermsAccepted = (user:User) => new Promise((resolve, reject)=>{
		$.ajax(GET_QUERY('/termsAccepted'))
			.done((response) => {
				user.agreedToTerms = new Date();
				resolve(response);
			})
			.fail((jqXHR, textStatus) => {
				reject(textStatus);
			});
	});

	createVendorAccount = (data:ICreateAccountData):Promise<any> => {
		data.isVendorBoothHost = true;
		return this.createUserAccount(data);
	}

	createUserAccount = (data:ICreateAccountData):Promise<any> => new Promise((resolve, reject)=>{
		const request = new XMLHttpRequest();
		request.onreadystatechange = () => {
			if(request.readyState == 4){
				const response = JSON.parse(request.responseText);
				if (request.status == 200) {
					resolve(response);
				} else {
					reject(response.userMessage);
				}
			}
		};
		request.open("POST", Transport.URL("/users"), true);
		request.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
		request.send(JSON.stringify(data));
	});


	loadMentionUsersForSolution = (solutionId:string, vendor?:boolean):Promise<IMentionUser[]> =>  new Promise((resolve, reject) => {
		API.get(`/${vendor?"vendor":"cmd"}/loadMentionUsersForSolution/${solutionId}`)
			.then((response:IMentionUser[]) => {
				resolve(response);
			})
			.catch((error) => {
				reject(error);
			})
	});


}




export interface ICreateAccountData {
	firstName:string;
	lastName:string;
	email:string;
	password:string;
	employeeOrSpouse:string;
	spouseName:string;
	locationId:string;
	employeeId:string;
	extra:string;
	isVendorBoothHost?:boolean;
	professionalTitle?:string;
	company?:string;
	bio?:string;
}





let UserDataSource = new _UserDataSource();
export default UserDataSource;
